import {
  Image,
  Modal,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { LinearGradient } from "expo-linear-gradient";

import React, { useEffect, useRef } from "react";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppColors } from "../../../../utility/AppColors";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import { AppImages } from "../../../../utility/AppImages";

export default function BeltPurchaseSuccessModal(props) {
  const {
    showModal = false,
    arrBeltMedalType = [],
    setShowModal,
    backProfileTapped,
    dataBuyBelt,
    numberOfBelts = "1",
  } = props;

  const onCloseClick = () => {
    setShowModal(false);
    if (backProfileTapped) {
      backProfileTapped();
    }
  };

  const styles = useStyles();
  const deviceSize = useDeviceSize();

  // Get the purchased belt data, defaulting to index 1 (Bronze) or first available
  const purchasedBelt = arrBeltMedalType?.[1] || arrBeltMedalType?.[0];

  // Store the initial belt amount in a ref so it doesn't disappear on re-render
  const beltAmountRef = useRef<number | string | null>(null);

  useEffect(() => {
    if (showModal && purchasedBelt?.purchasedBeltAmount) {
      beltAmountRef.current = purchasedBelt.purchasedBeltAmount;
    }
  }, [showModal, purchasedBelt?.purchasedBeltAmount]);

  // Use the ref value, or current value, or numberOfBelts as fallback
  const displayBeltAmount = beltAmountRef.current || purchasedBelt?.purchasedBeltAmount || numberOfBelts || 1;

  // If no belt data is available, don't render the modal
  if (!purchasedBelt) {
    console.warn('BeltPurchaseSuccessModal: No belt data available');
    return null;
  }

  // const token = dataBuyBelt.token * Number(numberOfBelts);
  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={showModal}
      onRequestClose={onCloseClick}
    >
      <View style={styles.container}>
        <LinearGradient
          colors={["#111827", "#000000"]}
          start={{ x: 0, y: 0 }}
          end={{ x: 1, y: 1 }}
          style={styles.mainView}
        >
          {/* Header view */}
          <View style={styles.headerView}>
            <View style={{ flex: 1, alignSelf: "center" }}>
              <Text style={[AppFontStyle.BOLD_ANYBODY_16, styles.headerText]}>
                Purchase successful
              </Text>
            </View>
            <TouchableOpacity
              style={{
                justifyContent: "flex-start",
                alignItems: "flex-start",
              }}
              activeOpacity={0.5}
              onPress={onCloseClick}
            >
              <Image
                source={AppImages.icCloseWhite}
                style={{
                  width: 30,
                  height: 30,
                  marginVertical: 5,
                  resizeMode: "contain",
                }}
              />
            </TouchableOpacity>
          </View>

          {(deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM) ? (
            <ScrollView
              showsVerticalScrollIndicator={false}
              contentContainerStyle={{ flexGrow: 1 }}
              style={{ flex: 1, width: "100%" }}
            >
              <View style={styles.beltWrapper}>
                <Text style={[AppFontStyle.REGULAR_ANYBODY_14, { color: "#FFF", marginBottom: 16 }]}>
                  You have successfully purchased{" "}
                  <Text style={{ fontWeight: "bold" }}>{displayBeltAmount}</Text>
                  {" " + purchasedBelt.title + " belt"}
                </Text>

                {/* Belt Card */}
                <LinearGradient
                  colors={["rgba(31, 41, 55, 0.50)", "rgba(17, 24, 39, 0.50)"]}
                  style={styles.imageWrapper}
                >
                  <Image
                    source={purchasedBelt.image}
                    style={styles.beltImage}
                  />
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_32,
                      { color: AppColors.white, marginTop: 10 },
                    ]}
                  >
                    {displayBeltAmount}
                  </Text>
                </LinearGradient>
              </View>
            </ScrollView>
          ) : (
            <View style={styles.beltWrapper}>
              <Text style={[AppFontStyle.REGULAR_ANYBODY_14, { color: "#FFF", marginBottom: 16 }]}>
                You have successfully purchased{" "}
                <Text style={{ fontWeight: "bold" }}>{displayBeltAmount}</Text>
                {" " + purchasedBelt.title + " belt"}
              </Text>

              {/* Belt Card */}
              <LinearGradient
                colors={["rgba(31, 41, 55, 0.50)", "rgba(17, 24, 39, 0.50)"]}
                style={styles.imageWrapper}
              >
                <Image
                  source={purchasedBelt.image}
                  style={styles.beltImage}
                />
                <Text
                  style={[
                    AppFontStyle.BOLD_ANYBODY_32,
                    { color: AppColors.white, marginTop: 10 },
                  ]}
                >
                  {displayBeltAmount}
                </Text>
              </LinearGradient>
            </View>
          )}

          <View style={{ paddingHorizontal: 0, paddingBottom: 20, flexDirection: 'row', gap: 12, width: '100%' }}>
            <TouchableOpacity
              style={[styles.confirmButton, { backgroundColor: 'transparent', borderWidth: 1, borderColor: '#FFF', flex: 1, paddingVertical: 12 }]}
              onPress={onCloseClick}
            >
              <Text
                style={[AppFontStyle.BOLD_ANYBODY_14, { color: '#FFF' }]}
              >
                Close
              </Text>
            </TouchableOpacity>

            {backProfileTapped && (
              <TouchableOpacity
                style={[styles.confirmButton, { backgroundColor: '#DC2626', flex: 2, paddingVertical: 12 }]}
                onPress={() => {
                  onCloseClick();
                }}
              >
                <Text
                  style={[AppFontStyle.BOLD_ANYBODY_14, { color: '#FFF' }]}
                >
                  Back to Profile
                </Text>
              </TouchableOpacity>
            )}
          </View>
        </LinearGradient>
      </View>
    </Modal>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      flex: 1,
      backgroundColor: AppColors.blackTrans_000000a8,
      justifyContent: "center",
      alignItems: "center",
    },
    mainView: {
      width: "35%",
      maxHeight: "70%",
      backgroundColor: AppColors.black_121212,
      paddingHorizontal: 30,
      marginHorizontal: 40,
      marginVertical: 50,
      alignSelf: "center",
      borderRadius: 12,
      borderColor: AppColors.buttonRed_DC2626,
      borderWidth: 1,
    },
    headerView: {
      marginTop: 16,
      flexDirection: "row",
      justifyContent: "space-between",
      paddingVertical: 10,
      gap: 10,
    },
    headerText: {
      color: AppColors.white,
      fontSize: 16,
    },
    divider: {
      height: 2,
      alignSelf: "center",
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      width: "100%",
    },
    beltImage: {
      width: 150,
      height: 200,
      resizeMode: "contain",
    },
    confirmButton: {
      marginTop: 20,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      borderRadius: 10,
      justifyContent: "center",
      alignItems: "center",
    },
    confirmButtonText: {
      paddingVertical: 16,
      color: AppColors.white,
    },
    beltWrapper: {
      flex: 1,
      marginVertical: 22,
    },
    imageWrapper: {
      flex: 1,
      minHeight: 200,
      borderRadius: 8,
      borderWidth: 0.8,
      borderColor: "#374151",
      width: "100%",
      padding: 20,
      marginTop: 8,
      alignItems: "center",
      justifyContent: "center",
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      mainView: {
        width: "35%",
        // backgroundColor: AppColors.black_121212, // Removed, handled by LinearGradient
        paddingHorizontal: 20,
        marginHorizontal: 40,
        marginVertical: 50,
        alignSelf: "center",
        borderRadius: 16,
        borderColor: "#DC2626",
        borderWidth: 1,
        borderTopWidth: 1, // Ensure visible
        shadowColor: "rgba(232, 232, 232, 0.15)",
        shadowOffset: { width: 0, height: -3 },
        shadowOpacity: 0.8,
        shadowRadius: 14,
      },
      // ... keep other LG styles but update imageWrapper/beltImage if needed
    },
    // ... update other breakpoints similarly below if needed to override mainView backgroundColor
    [DEVICE_SIZES.MD]: {
      mainView: {
        width: "50%",
        paddingHorizontal: 20,
        marginHorizontal: 40,
        marginVertical: 50,
        alignSelf: "center",
        borderRadius: 16,
        borderColor: "#DC2626",
        borderWidth: 1,
        // backgroundColor removed
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "flex-end",
        alignItems: "center",
      },
      mainView: {
        width: "100%",
        maxHeight: "60%",
        paddingHorizontal: 20,
        marginHorizontal: 0,
        marginVertical: 0,
        alignSelf: "center",
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderColor: "#DC2626",
        borderWidth: 1,
        borderBottomWidth: 0,
      },
      beltImage: {
        width: 100,
        height: 100,
        resizeMode: "contain",
      },
      imageWrapper: {
        height: 163,
        borderRadius: 8,
        borderWidth: 0.8,
        borderColor: "#374151",
        width: "100%",
        padding: 20,
        marginTop: 8,
        alignItems: "center",
        justifyContent: "center",
      },
    },
    [DEVICE_SIZES.XS]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.blackTrans_000000a8,
        justifyContent: "flex-end",
        alignItems: "center",
      },
      mainView: {
        width: "100%",
        maxHeight: "60%",
        paddingHorizontal: 20,
        marginHorizontal: 0,
        marginVertical: 0,
        alignSelf: "center",
        borderTopLeftRadius: 16,
        borderTopRightRadius: 16,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        borderColor: "#DC2626",
        borderWidth: 1,
        borderBottomWidth: 0,
      },
      beltImage: {
        width: 80,
        height: 80,
        resizeMode: "contain",
      },
      imageWrapper: {
        height: 163,
        borderRadius: 8,
        borderWidth: 0.8,
        borderColor: "#374151",
        width: "100%",
        padding: 20,
        marginTop: 8,
        alignItems: "center",
        justifyContent: "center",
      },
    },
  }
);
